module.exports = __webpack_public_path__ + "img/result-rank-bg.1ad21920.png";